import FragmentMetadata from './fragment-metadata';
import MetadataStore from './metadata-store';

export const BREAKPOINTS = '@breakpoints';
export const LOCALES = '@locales';
export const RENDER = '@render';

export type Value = boolean | number | object | string | undefined | null;

export interface Props {
  [key: string]: Value;
}

export interface NodeProps extends Props {
  uuid: string;
  alias?: string;
  [RENDER]?: boolean;

  [LOCALES]?: {
    [key: string]: Props;
  };

  [BREAKPOINTS]?: {
    [key: string]: Props;
  };
}

export interface Node {
  type: string;
  props: NodeProps;
  children?: Node[];
}

export interface Metadata {
  name: string;
  metadata: Node;
}

export { FragmentMetadata, MetadataStore };
